/* tslint:disable */
/* eslint-disable */
/**
 * UPM-metsa-api
 * UPM Metsä API specification
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PackingContainerType {
    Cardboard = 'CARDBOARD',
    Plastic = 'PLASTIC',
    Bag = 'BAG'
}

export function PackingContainerTypeFromJSON(json: any): PackingContainerType {
    return PackingContainerTypeFromJSONTyped(json, false);
}

export function PackingContainerTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PackingContainerType {
    return json as PackingContainerType;
}

export function PackingContainerTypeToJSON(value?: PackingContainerType | null): any {
    return value as any;
}

